import type { SVGComponentProps } from 'BreetHelpers';

export const ResolutionFeeIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='32'
		height='32'
		viewBox='0 0 32 32'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<rect
			width='32'
			height='32'
			rx='16'
			fill='#F7F8F8'
		/>
		<path
			opacity='0.4'
			d='M19.3333 21.6668H12.6666C10.6666 21.6668 9.33325 20.6668 9.33325 18.3335V13.6668C9.33325 11.3335 10.6666 10.3335 12.6666 10.3335H19.3333C21.3333 10.3335 22.6666 11.3335 22.6666 13.6668V18.3335C22.6666 20.6668 21.3333 21.6668 19.3333 21.6668Z'
			fill='#022745'
		/>
		<path
			d='M16 18C17.1046 18 18 17.1046 18 16C18 14.8954 17.1046 14 16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18Z'
			fill='#022745'
		/>
		<path
			d='M11.6667 18.1668C11.3934 18.1668 11.1667 17.9402 11.1667 17.6668V14.3335C11.1667 14.0602 11.3934 13.8335 11.6667 13.8335C11.9401 13.8335 12.1667 14.0602 12.1667 14.3335V17.6668C12.1667 17.9402 11.9401 18.1668 11.6667 18.1668Z'
			fill='#022745'
		/>
		<path
			d='M20.3335 18.1668C20.0602 18.1668 19.8335 17.9402 19.8335 17.6668V14.3335C19.8335 14.0602 20.0602 13.8335 20.3335 13.8335C20.6068 13.8335 20.8335 14.0602 20.8335 14.3335V17.6668C20.8335 17.9402 20.6068 18.1668 20.3335 18.1668Z'
			fill='#022745'
		/>
	</svg>
);
